/* eslint-disable no-undef */
import helpers from '../helpers';

$(document).ready(() => {
	const header = $('.header');
	const menu = $('.header__menu');
	const track = $('.scrollbar-track');

	$('#header_menu_btn').on('change', function () {
		const isChecked = $(this).is(':checked');

		helpers.lockScroll(isChecked, menu);

		if (!helpers.isMobile) {
			scrollbar.updatePluginOptions('modal', {open: !!isChecked});
		}

		track.toggleClass('show');
		header.toggleClass('is-menu', isChecked);
		menu.toggleClass('show', isChecked);
	});

	$('.header__menu-item').on('click', () => {
		$('#header_menu_btn')[0].checked = false;

		helpers.lockScroll(false, menu);
		if (!helpers.isMobile) {
			scrollbar.updatePluginOptions('modal', {open: false});
		}

		header.removeClass('is-menu');
		menu.removeClass('show');
	});
});
